import React from "react";
import { twMerge } from "tailwind-merge";

interface ColorInputProps {
  id?: string;
  value: string;
  onChange: (hex: string) => void;
  disabled?: boolean;
  className?: string;
  title?: string;
  "aria-label"?: string;
}

export const ColorInput: React.FC<ColorInputProps> = ({
  id,
  value,
  onChange,
  disabled,
  className,
  title,
  "aria-label": ariaLabel,
}) => (
  <input
    type="color"
    id={id}
    value={value}
    disabled={disabled}
    title={title}
    aria-label={ariaLabel}
    onChange={(e) => onChange(e.target.value)}
    className={twMerge(
      "block h-[42px] w-[42px] shrink-0 cursor-pointer rounded-md border border-gray-300 disabled:cursor-not-allowed disabled:opacity-50 md:h-[38px] md:w-[38px]",
      className
    )}
  />
);

export default ColorInput;
